const trains = {
  train: "רכבת", // translated
  trains: "רכבות", // translated
  fairConditions: "תנאים הוגנים", // translated
  to: "ל", // translated
  earlier: "מוקדם יותר", // translated
  later: "יותר מאוחר", // translated
  adults: "מבוגרים", // translated
  child: "יֶלֶד", // translated
  senior: "בָּכִיר", // translated
  seniors: "קשישים", // translated
  price: "מחיר", // translated
  for: "ל", // translated
  total: "total", // translated
  selected: "נבחר", // translated
  prebook: "הזמנה מראש", // translated
  book: "סֵפֶר", // translated
  payment: "תַשְׁלוּם", // translated
  return: "לַחֲזוֹר", // translated
  passengers: "נוסעים", // translated
  delivery: "מְסִירָה", // translated
  summary: "סיכום", // translated
  checkout: "לבדוק", // translated
  trainToastCorrectFillForm: "נא למלא כראוי את כל השדות.", // translated
  fareConditions: "תנאי תעריף", // translated
  travelInfo: "מידע על נסיעות", // translated
  remarks: "הערות לקוחות", // translated
  noServices: "אין שירותים", // translated
  timesAndSeats: "זמנים ומושבים", // translated
  mobileTicket: "כרטיס נייד", // translated
  stationTicket: "איסוף בתחנה", // translated
  homeTicket: "הדפס בבית", // translated
  countryCode: "קוד מדינה", // translated
  chooseTicket: "בחר שיטת משלוח כרטיסים", // translated
  ticketError: "אנא בחר כרטיס לכל היעדים", // translated
  ticketDelivery: "אנא בחר שיטת משלוח כרטיס", // translated
  passengerDetails: "פרטי נוסע", // translated
  waitWhileProcessingPayment: "אנא המתן בזמן שאנו מעבדים את התשלום שלך, אל תרענן ואל תסגור את הדף.", // translated
  reductionCardId: "מזהה כרטיס הפחתה", // translated
  countryOfResidence: "ארץ מגורים", // translated
  countryOfBirth: "ארץ לידה", // translated
  documentCountry: "ארץ מסמך", // translated
  documentNumber: "מספר מסמך", // translated
  expirationDate: "תאריך תפוגה", // translated
  documentType: "סוג מסמך", // translated
  travelerDocumentInfo: "מידע על מסמך הנוסע", // translated
  youth: "נוֹעַר", // translated
  youths: "בני נוער", // translated
  departTimeEarlyFirst: "שעת יציאה (המוקדם ביותר ראשון)", // translated
};


export default trains;
